import type { CustomerAction } from '@ghostwright/api-client';

interface TransitionCardProps {
  summary: string;
  nextTopicHint: string;
  onAction: (action: CustomerAction) => void;
  disabled?: boolean;
}

export default function TransitionCard({ summary, nextTopicHint, onAction, disabled }: TransitionCardProps) {
  return (
    <div className="mb-8 border-l-2 border-primary/60 bg-card rounded-r-card p-5 sm:p-6">
      <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-3">
        Captured
      </div>
      <p className="font-display italic text-base leading-relaxed text-foreground mb-4 [font-variation-settings:'opsz'_48,'SOFT'_80]">
        {summary}
      </p>
      <div className="flex items-center justify-between gap-3">
        <span className="text-xs text-muted-foreground">
          Next: {nextTopicHint}
        </span>
        <button
          type="button"
          disabled={disabled}
          onClick={() => onAction({ kind: 'acknowledge-transition' })}
          className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground text-sm font-medium py-2 px-4 rounded-button min-h-[44px] shadow-[inset_0_1px_0_hsl(var(--primary-foreground)/0.15)] transition-[opacity,transform] duration-80 ease-out hover:opacity-90 active:scale-[0.98] disabled:opacity-50"
        >
          Continue
          <span aria-hidden="true">&rarr;</span>
        </button>
      </div>
    </div>
  );
}
